import { YnEnum } from '@/enums/common.enums';
import dayjs from 'dayjs';

export const issueUtils = () => {
    const addYearsAndMonths = () => {
        const yearList = [];
        const monthList = [];
        const currentYear = dayjs().year(); 
        for (let i = 1900; i <= currentYear; i++) {
            yearList.push(i);
        }
        for (let i = 1; i <= 12; i++) {
            monthList.push(i);
        }
        return { yearList, monthList };
    };

    const getSelectedDatePart = (object, part) => {
        if (!object) return null;
        if (typeof object === 'string') {
            const parts = object.split('/');
            return part === 'year' ? parts[0] : parseInt(parts[1]).toString();
        } else if (typeof object === 'object' && object !== null) {
            return part === 'year' ? object.getFullYear() : object.getMonth() + 1;
        }
        return null;
    };

    const handleYear = (date, formattedDate, year) => {
        if (!year) return { date, formattedDate };

        const today = dayjs();
        const currentMonth = today.month() + 1; 
        const currentDay = today.date();

        let newDate, newFormattedDate;
    
        if (date) {
            const parts = date.split('/');
            parts[0] = year.toString();
            newDate = parts.join('/');
        
            const formattedParts = formattedDate.split('/');
            formattedParts[0] = year.toString();
            newFormattedDate = formattedParts.join('/');
        } else {
            newDate = `${year}/${currentMonth.toString().padStart(2, '0')}/${currentDay.toString().padStart(2, '0')}`;
            newFormattedDate = newDate;
        }
    
        return { newDate, newFormattedDate };
    }

    const handleMonth = (date, formattedDate, month) => {
        if (!month) return { date, formattedDate };

        const parts = date.split('/');
        parts[1] = month.toString().padStart(2, '0'); // Ensure it's two digits
        const newDate = parts.join('/');
    
        const formattedParts = formattedDate.split('/');
        formattedParts[1] = month.toString().padStart(2, '0');
        const newFormattedDate = formattedParts.join('/');
    
        return { newDate, newFormattedDate };
    }

    const checkIsYearSelected = (year, day) => {
        if(!day) return '';

        if(typeof day === 'string') {
            if(day.split('/')[0] === year.toString()) {
                return 'selected';
            } else {
                return '';
            }
        } else if(typeof day === 'object' && day !== null) {
            if(day.getFullYear() === year){
                return 'selected';
            } else {
                return '';
            }
        }
        return '';
    }

    const checkIsMonthSelected = (month, day) => {
        if(!day) return '';

        if(typeof day === 'string') {
            const newMonth = parseInt(day.split('/')[1]).toString();
            if(newMonth === month.toString()) {
                return 'selected';
            } else {
                return '';
            }
        } else if(typeof day === 'object' && day !== null) {
            if(day.getMonth() + 1 === month){
                return 'selected';
            } else {
                return '';
            }
        }
        return '';
    }

    const formatDayForVueDatepicker = (date) => {
        if (!date) return '';
        return dayjs(date).format('YYYY/MM/DD');  
    };
    
    const convertDate = (dateString) => {
        if (!dateString) return '-';
        return dayjs(dateString).format('YYYY/MM/DD');
    };

    const urlValidator = (url) => {
        if(!url) return false;
        if(typeof url !== 'string') return false;
        if(url.startsWith('http://') || url.startsWith('https://')) return true;
        return false;
    }

    return {
        addYearsAndMonths,
        getSelectedDatePart,
        handleYear,
        handleMonth,
        checkIsYearSelected,
        checkIsMonthSelected,
        formatDayForVueDatepicker,
        convertDate,
        urlValidator,
        // (제거) convertPolicyYn('필수'/'선택')·getBracePartText('양악'/'상악'/'하악')
        // — 한국어 문구를 반환하던 미번역 함수. 호출처 0건 실측 후 제거(2026-08-13).
        // 되살릴 때는 i18n 키를 거쳐 반환할 것.
    };
};